/* eslint-disable */
import * as utilLogin from "@/api/login";
import { removeShowModalPromo, getShowModalPromo, setShowModalPromo, removeMemberSession, setMemberSession, getMemberSession, setXAuthAgent, setAgentSession, removeAgentSession, removeXAuthAgent, setXAuthToken, removeXAuthToken } from "@/utils/auth";

const state = {
    roles: [],
    username: "",
    password: "",
    x_auth_token: "",
    showModalPromo: (getShowModalPromo() != null) ? getShowModalPromo() : null,
    memberSession: (getMemberSession() != null) ? JSON.parse(getMemberSession()) : null,
};

const mutations = {
    SET_showModalPromo: (state, value) => {
        state.showModalPromo = value
    },
    SET_memberSession: (state, value) => {
        state.memberSession = value
    },
    SET_x_auth_token: (state, value) => {
        state.x_auth_token = value
    },
    SET_Roles: (state, value) => {
        state.roles = value
    },
};

const actions = {
    actHideModalPromo({ commit }) {
        commit("SET_showModalPromo", "hide");
        setShowModalPromo("hide");
    },
    loginAgentStored({ commit, dispatch }, dataParams) {
        commit("SET_x_auth_token", "");
        removeXAuthToken();
        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });

        return new Promise((resolve, reject) => {
            utilLogin.loginAgentStored(dataParams).then(response => {
                const { data } = response;
                setXAuthToken(data.x_auth_token)
                commit("SET_x_auth_token", data.x_auth_token);
                setXAuthAgent(data.x_auth_agent)
                setAgentSession(data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBankList({ commit }) {
        return new Promise((resolve, reject) => {
            utilLogin.getBankList().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBank({ commit }) {
        return new Promise((resolve, reject) => {
            utilLogin.getBank().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getProfile({ commit }, dataParams) {
        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });

        return new Promise((resolve, reject) => {
            utilLogin.getProfile(dataParams).then(response => {
                const { data } = response;
                if (!data) {
                    reject('Verification failed, please Login again.')
                }

                const { roles } = data

                // roles must be a non-empty array
                if (!roles || roles.length <= 0) {
                    reject('getInfo: roles must be a non-null array!')
                }
                commit("SET_memberSession", data);
                setMemberSession(data)

                commit("SET_Roles", data.roles);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setFields({ commit }, data) {
        commit("SET_fields", data);
    },
    loginMemberValidation({ commit }, dataParams) {
        // console.log(dataParams)
        commit("SET_x_auth_token", "");
        removeXAuthToken()
        removeMemberSession()
        removeAgentSession({ "agentSession": {} });
        removeXAuthAgent("");

        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });
        return new Promise((resolve, reject) => {
            utilLogin.loginMemberValidation(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    loginMemberStored({ commit, dispatch }, dataParams) {
        commit("SET_x_auth_token", "");
        removeXAuthToken();
        removeMemberSession()
        commit("SET_memberSession", {
            "email": "",
            "id": "",
            "name": "",
            "phone": "",
            "roles": [],
            "timezone": "Asia/Jakarta"
        });

        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });
        // dispatch("/agent/setAgentSession", { "agentSession": {} })
        // dispatch("/agent/setXAuthAgent", "")


        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            utilLogin.loginMemberStored(dataParams).then(response => {
                const { data } = response;
                setXAuthToken(data.x_auth_token)
                commit("SET_x_auth_token", data.x_auth_token);
                // commit("SET_Roles", data.roles);
                // console.log("x-auth-token", data.x_auth_token)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    logout({ commit }, dataParams) {

        return new Promise((resolve, reject) => {
            utilLogin.logout(dataParams).then(response => {
                commit("SET_memberSession", {
                    "email": "",
                    "id": "",
                    "name": "",
                    "phone": "",
                    "roles": [],
                    "timezone": "Asia/Jakarta"
                });
                removeMemberSession()
                // const { data } = response;
                commit('SET_x_auth_token', '')
                commit('SET_Roles', [])
                removeXAuthToken()
                removeXAuthAgent("");
                removeAgentSession({ "agentSession": {} });
                removeShowModalPromo();
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    removeXAuthToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_x_auth_token', '')
            commit('SET_Roles', [])
            removeXAuthToken()

            resolve()
        })
    },
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_memberSession", {
                "email": "",
                "id": "",
                "name": "",
                "phone": "",
                "roles": [],
                "timezone": "Asia/Jakarta"
            });
            removeMemberSession()
            // const { data } = response;
            commit('SET_x_auth_token', '')
            commit('SET_Roles', [])
            removeXAuthToken()
            removeXAuthAgent("");
            removeAgentSession({ "agentSession": {} });
            removeShowModalPromo();

            resolve()
        })
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js